import { render, staticRenderFns } from "./communityConsultation.vue?vue&type=template&id=4e2e788d&scoped=true&"
import script from "./communityConsultation.vue?vue&type=script&lang=js&"
export * from "./communityConsultation.vue?vue&type=script&lang=js&"
import style0 from "./communityConsultation.vue?vue&type=style&index=0&id=4e2e788d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e788d",
  null
  
)

export default component.exports